import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

import getGroupNationalTeamInvitesData from './GetGroupNationalTeamInvitesData';
import getGroupNationalTeamInviteWorkflowData from '../GetWorkFlowByIdData';
import putGroupNationalTeamInviteWorkflowData from '../PutWorkFlowData';

const GroupNationalTeamInviteData = {
  INITIAL_STATE: {...BASIC_INITIAL_STATE},
  getGroupNationalTeamInvitesData,
  getGroupNationalTeamInviteWorkflowData,
  putGroupNationalTeamInviteWorkflowData
};

export default GroupNationalTeamInviteData;